var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "vs-select",
    {
      staticClass: "w-full",
      attrs: { clearable: false, disabled: _vm.loading },
      on: { input: _vm.setCurrencies },
      model: {
        value: _vm.currencySelected,
        callback: function ($$v) {
          _vm.currencySelected = $$v
        },
        expression: "currencySelected",
      },
    },
    [
      _vm._l(_vm.currencies, function (item, index) {
        return _c("vs-select-item", {
          key: index,
          attrs: { value: item.value, text: item.text },
        })
      }),
      _c("span", { attrs: { slot: "no-options" }, slot: "no-options" }, [
        _vm._v("Nada que mostrar."),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }